import $ from 'swiper/esm/utils/dom';
import {scrollTo} from 'dom7/dom7.esm';
$.fn['scrollTo'] = scrollTo;

let common = require('./modules/common');
common.init();

let internals = {
    initSlider: function (Swiper) {
        let slider =new Swiper('#slider_gallery', {
            autoplay: false,
            loop: false,
            lazy: {
                loadPrevNext: true,
            },
            watchSlidesVisibility: true,
            spaceBetween: 0,
            slidesPerView: 'auto',
            allowTouchMove: true,
            slideClass: 'hex__item',
            wrapperClass: 'swiper-wrapper',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    allowTouchMove: false
                }
            },
            init: false
        });

        common.observeSlider('slider_gallery', slider)
    },
    initVideo: function () {
        if (document.getElementById('ytplayer_1')) {
            common.observeCallback('ytplayer_1', function () {
                window['onYouTubePlayerAPIReady'] = function () {
                    document.querySelectorAll('.video-player').forEach(
                        function (el) {
                            new YT.Player(el.id, {
                                height: '390',
                                width: '640',
                                playerVars: {
                                    autoplay: 0,
                                    rel: 0
                                },
                                videoId: el.getAttribute('data-code'),
                                origin: 'https://logospak.com'
                            });
                        }
                    );
                };

                let s = document.createElement('script');
                s.src = 'https://www.youtube.com/player_api';
                s.async = true;
                s.defer = true;
                document.body.appendChild(s);
            });
        }
    },
    initNewsSlider: function (Swiper) {
        internals.newsSlider = new Swiper('#slider_news', {
            autoplay: false,
            loop: false,
            init: false,
            spaceBetween: 0,
            slidesPerView: 'auto',
            allowTouchMove: true,
            breakpoints: {
                768: {
                    allowTouchMove: false
                }
            },
        });
        common.observeSlider('slider_news', internals.newsSlider);
    },
    initForm: function () {
        let form = document.getElementById('page-form');

        if (form === null) {
            return;
        }

        import(/* webpackChunkName: "validation" */'./modules/validation').then(function (validation) {
            let plugins = {
                declarative: new validation.DeclarativePlugin(),
                submitButton: new validation.SubmitButtonPlugin(),
                bootstrap: new validation.BootstrapPlugin({
                    rowSelector: '.order-form__group'
                }),
                trigger: new validation.TriggerPlugin()
            };

            if (form.getAttribute('data-fvp-recaptcha___element')) {
                plugins.recaptcha = new validation.RecaptchaPlugin({
                    element: form.getAttribute('data-fvp-recaptcha___element'),
                    language: form.getAttribute('data-fvp-recaptcha___language'),
                    message: form.getAttribute('data-fvp-recaptcha___message'),
                    siteKey: form.getAttribute('data-fvp-recaptcha___site-key'),
                    theme: form.getAttribute('data-fvp-recaptcha___theme'),
                    size: form.getAttribute('data-fvp-recaptcha___size'),
                    badge: form.getAttribute('data-fvp-recaptcha___badge')
                });
            }

            let fv = validation.fv(form, {plugins: plugins}).on('core.form.valid', function () {
                common.submitForm(fv.getFormElement()).then(function (response) {

                    if (form.data('goal')) {
                        let tracking = require('./modules/tracking');
                        tracking.reachGoal(form.data('goal'));
                    }

                    form.innerHTML = response.message;
                });
            });
            validation.initIntlTelInput();

        });
    }
};

if (document.getElementById('slider_gallery')) {
    import(/* webpackChunkName: "swiper" */ './modules/swiper').then(function (module) {
        internals.initSlider(module.default);
    }, function (e) {
        throw new Error('Unable to load swiper library: ' + e.message);
    });
}

if (document.getElementById('slider_news')) {
    import(
        /* webpackChunkName: "swiper" */
        './modules/swiper').then(function (module) {
        internals.initNewsSlider(module.default);
    }, function (e) {
        throw new Error('Unable to load swiper library: ' + e.message);
    });
}

internals.initVideo();
internals.initForm();
common.initLightBox('[data-product-lightbox]')